module.exports = __webpack_public_path__ + "img/20190612_132334_020.b8465968.jpg";